import { HotKey } from '../../../models/hotkey';
import { useEffect, useRef } from 'react';
import { useContainer } from '@bydesign-ui/hooks';
import { useSingleton } from '@bydesign-ui/hooks';
export function useCreateHotKey(ele) {
  var elemGetter = useContainer(ele);
  var prevElemRef = useRef(null);
  var hotkey = useSingleton(function () {
    return new HotKey();
  });
  useEffect(function () {
    var elem = elemGetter();

    if (elem !== prevElemRef.current) {
      prevElemRef.current = elem;

      if (elem) {
        hotkey.init(elem);
      } else {
        hotkey.dispose();
      }
    }
  });
  return hotkey;
}